import { useEffect, useRef } from "react";
import { useSearchParams } from "react-router-dom";
import { useFloatingConciergeUi } from "@/contexts/FloatingConciergeContext";

/**
 * Opens the floating concierge when authed routes carry `?floating=open`
 * (e.g. redirect from /chat). Preserves brief / recipient query params,
 * then strips `floating` from the URL so refresh doesn't re-trigger.
 */
export function useFloatingConciergeDeepLink() {
  const [searchParams, setSearchParams] = useSearchParams();
  const { applyConciergeDeepLink } = useFloatingConciergeUi();
  const handledRef = useRef<string | null>(null);

  useEffect(() => {
    if (searchParams.get("floating") !== "open") return;

    const fingerprint = searchParams.toString();
    if (handledRef.current === fingerprint) return;
    handledRef.current = fingerprint;

    applyConciergeDeepLink(searchParams);

    const next = new URLSearchParams(searchParams);
    next.delete("floating");
    setSearchParams(next, { replace: true });
  }, [searchParams, setSearchParams, applyConciergeDeepLink]);
}
